import { Popup } from 'Lib/popup/popup';
import { cloudpayments } from 'Lib/cloudpayments/cloudpayments';

const elsBtnOrder = Array.from(document.querySelectorAll('.offer-list__list-item-info-btn'));
const elsPopupInputs = Array.from(document.querySelectorAll('.offer-list__item-popup .mail-form__required'));
const elPopupBtn = document.querySelector('.offer-list__item-popup .offer-list__payment');
const dataOrder = {};

elsBtnOrder?.forEach((item) => {
    item.addEventListener('click', (e) => {
        const target = e.target;
        const elParent = target.closest('.offer-list__item');

        dataOrder.serviceTypeName = elParent.getAttribute('data-element-name');
        dataOrder.price = +elParent.querySelector('.offer-list__list-item-info-price-num').textContent;
        dataOrder.invoiceId = elParent.getAttribute('data-invoice-id');
        dataOrder.serviceId = elParent.getAttribute('data-service-id');
        dataOrder.email = document.querySelector('.offer-list__item-popup .mail-form__input[name=email]').value;

        const popup = new Popup('popup', document.querySelector('.offer-list__item-popup'));

        popup.open();
    });
});

elsPopupInputs.forEach((item) => {
    item.addEventListener('input', () => {
        if (item.validity.valid) {
            const errorElement = item.nextElementSibling;

            errorElement.classList.remove('mail-form__cont-input-error_active');
            errorElement.textContent = '';
        } else {
            const errorElement = item.nextElementSibling;

            errorElement.textContent = item.validationMessage;
            errorElement.classList.add('mail-form__cont-input-error_active');
        }

        if (!elsPopupInputs.some((input) => !input.validity.valid) && document.querySelector('.mail-form__input_checkbox').checked) {
            elPopupBtn.classList.remove('btn_disabled');
            elPopupBtn.removeAttribute('disabled');
        } else {
            elPopupBtn.classList.add('btn_disabled');
            elPopupBtn.setAttribute('disabled', 'true');
        }
    });
});

document.querySelector('.offer-list__payment')?.addEventListener('click', (e) => {
    e.preventDefault();

    const target = e.target;

    dataOrder.publicId = target.getAttribute('data-cloud-payments-id');
    dataOrder.vat = target.getAttribute('data-vat');
    dataOrder.measure = target.getAttribute('data-measure');

    dataOrder.receipt = {
        'Items': [
            {
                'label': dataOrder.serviceTypeName, // наименование товара
                'price': dataOrder.price, // цена
                'quantity': '1.00', // количество
                'amount': dataOrder.price, // сумма
                'vat': +dataOrder.vat, // ставка НДС
                'method': 1,
                'object': 4, // тег-1212 признак предмета расчета - признак предмета товара, работы, услуги, платежа, выплаты, иного предмета расчета
                'measurementUnit': dataOrder.measure, // единица измерения
            },
        ],
        'TaxationSystem': 0,
        'amounts': {
            electronic: dataOrder.price,
        },
    };

    dataOrder.additionData = {
        phone: document.querySelector('.offer-list__item-popup .mail-form__input[name=phone]').value,
        telegram: document.querySelector('.offer-list__item-popup .mail-form__input[name=telegram]')?.value || '',
        email: document.querySelector('.offer-list__item-popup .mail-form__input[name=email]').value,
    };

    cloudpayments(dataOrder, document.querySelector('.offer-list')?.getAttribute('data-redirect') || 'https://bookstart.eksmo.ru/?params=%7B%7D&target=9rx5dfg56gfqub2coyyplnx7g');
});